module.exports = __webpack_public_path__ + "static/media/oxforf1997.2c53d7ce.jpg";